import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import Leaves from "./Leaves";
import Approvals from "./Approvals";
import "../../assets/scss/tables.scss";
import "./LeavesPage.scss";

/* Both leave screens live here now. The old paths still resolve — /approvals
   simply opens on its own tab — so existing links and the notification deep
   links from leaveRequest.ctrl.js keep working. */
const Panel = ({ children, value, index }) => (
    <div role="tabpanel" hidden={value !== index}
        id={`leaves-panel-${index}`}
        aria-labelledby={`leaves-tab-${index}`}>
        {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
);

const LeavesAndApprovals = () => {

    const location = useLocation();

    const { user } = useSelector((state) => state.WorkHubAppSlice);
    /* the same gate the sidebar used to put on the Team Leave Approvals entry */
    const canApprove = Boolean(user?.roles?.isLeaveApprover);

    /* /approvals opens on the approvals tab, /leaveRequests on mine */
    const [value, setValue] = useState(
        canApprove && location.pathname.startsWith("/approvals") ? 1 : 0);

    return (
        <div className="wh-table leaves-approvals-page">
            <Tabs value={value} onChange={(e, v) => setValue(v)}
                aria-label="leaves and approvals" className="wh-tabs">
                <Tab label="My Leaves" disableRipple
                    icon={<EventNoteOutlinedIcon />} iconPosition="start"
                    id="leaves-tab-0" aria-controls="leaves-panel-0" />
                {canApprove && <Tab label="Team Leave Approvals" disableRipple
                    icon={<FactCheckOutlinedIcon />} iconPosition="start"
                    id="leaves-tab-1" aria-controls="leaves-panel-1" />}
            </Tabs>

            <Panel value={value} index={0}><Leaves /></Panel>
            {canApprove && <Panel value={value} index={1}><Approvals /></Panel>}
        </div>
    );
};

export default LeavesAndApprovals;
